import '../sass/style.scss';
import accordion from './modules/accordion';
import setViewport from './modules/setViewport';
import headerModules from './modules/headerModules';
import menuButton from './modules/menuButton';
import smoothScroll from './modules/smoothScroll';
import slider from './modules/slider';
import zoomImage from './modules/zoomImage';
import lazyLoad from './modules/lazyLoad';
import adjustHashPos from './modules/adjustHashPos';
import animation, { refreshScrollTrigger } from './modules/animation';
// import pageTransition from './modules/pageTransition';

const subPage = document.querySelector('.p-subPage');

setViewport();
zoomImage();

document.addEventListener('DOMContentLoaded', () => {
  if (subPage) {
    subPage.classList.add('content-load');
  }
  accordion();
  headerModules();
  menuButton();
  smoothScroll();
  slider();
  lazyLoad();
  animation();
});


window.addEventListener('load', () => {
  // homeMainVisualAnimation();
  adjustHashPos();
  refreshScrollTrigger();
  // setTimeout(() => {
  //   pageTransition();
  // });
});
